import { render, staticRenderFns } from "./NodeSettingsTabs.vue?vue&type=template&id=4a3ebc0c&"
import script from "./NodeSettingsTabs.vue?vue&type=script&lang=ts&"
export * from "./NodeSettingsTabs.vue?vue&type=script&lang=ts&"
import style0 from "./NodeSettingsTabs.vue?vue&type=style&index=0&id=4a3ebc0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports